import { render, staticRenderFns } from "./photoroll.vue?vue&type=template&id=277fe8ae&scoped=true&"
import script from "./photoroll.vue?vue&type=script&lang=ts&"
export * from "./photoroll.vue?vue&type=script&lang=ts&"
import style0 from "./photoroll.vue?vue&type=style&index=0&id=277fe8ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277fe8ae",
  null
  
)

export default component.exports